import React, { Component } from "react";
import { message, Space, Alert, Checkbox } from "antd";
import { FilePdfOutlined, FileExcelOutlined } from "@ant-design/icons";
import axios from "axios";
import { connect } from "react-redux";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { ModalItem, ButtonItem } from "../../../../Components/Items";
import borradorAguinaldoPdf from "../../../../Pdf/borradorAguinaldoPdf";
import { descargarExcelAguinaldo } from "./aguinaldoExcel";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

/**
 * PDF y Excel del borrador de aguinaldo (o del aguinaldo ya aplicado). Los datos los arma
 * nomina/datosImpresionAguinaldo; el ISR del borrador es el que se guardó con "Calcular ISR".
 * El PDF trae el detalle compacto (caben 100+ empleados en pocas hojas) y al final la hoja de
 * totales; "Columna de firma" agrega el espacio para firmar de recibido.
 */
class ModalImpresionAguinaldo extends Component {
  iframeRef = React.createRef();
  urlPdf = null;
  definicion = null;
  state = { cargando: false, datos: null, conFirma: false };

  componentDidMount() {
    if (this.props.visible && this.props.procesoId) this.cargar();
  }

  componentDidUpdate(prevProps) {
    const abrio = this.props.visible && !prevProps.visible;
    const cambio = this.props.visible && this.props.procesoId !== prevProps.procesoId;
    if ((abrio || cambio) && this.props.procesoId) this.cargar();
  }

  componentWillUnmount() {
    if (this.urlPdf) URL.revokeObjectURL(this.urlPdf);
  }

  async cargar() {
    const { empresaId, headersToken, procesoId } = this.props;
    this.setState({ cargando: true, datos: null });
    try {
      const res = await axios.post(
        "nomina/datosImpresionAguinaldo",
        { empresaId, id: procesoId },
        { headers: headersToken }
      );
      if (res.data.success === 2) {
        this.setState({ datos: res.data }, () => this.armarPdf());
      } else {
        message.error(res.data.message || "No se pudo armar el PDF");
      }
    } catch {
      message.error("Error de conexión al armar el PDF");
    }
    this.setState({ cargando: false });
  }

  armarPdf() {
    const { datos, conFirma } = this.state;
    if (!datos) return;
    this.definicion = borradorAguinaldoPdf(datos, { conFirma });
    this.mostrarPdf(pdfMake.createPdf(this.definicion));
  }

  // Con `location.replace` el PDF se muestra sin dejar una entrada en el historial (pdf.open sí la
  // deja y un goBack posterior sólo regresaría el iframe). Mismo arreglo que VistaPreviaVenta.
  mostrarPdf(pdf) {
    pdf.getBlob((blob) => {
      const iframe = this.iframeRef.current;
      if (!iframe?.contentWindow) return;
      if (this.urlPdf) URL.revokeObjectURL(this.urlPdf);
      this.urlPdf = URL.createObjectURL(blob);
      iframe.contentWindow.location.replace(this.urlPdf);
    });
  }

  descargarPdf = () => {
    if (!this.definicion) return;
    const d = this.state.datos;
    const sufijo = d?.aplicado ? "" : " (borrador)";
    pdfMake.createPdf(this.definicion).download(`Aguinaldo ${d?.proceso?.ejercicio || ""}${sufijo}.pdf`);
  };

  descargarExcel = () => {
    if (!this.state.datos) return;
    try {
      descargarExcelAguinaldo(this.state.datos);
    } catch (err) {
      console.error("[aguinaldo] Excel", err);
      message.error("No se pudo generar el Excel");
    }
  };

  render() {
    const { visible, onCancel } = this.props;
    const { cargando, datos, conFirma } = this.state;
    return (
      <ModalItem
        title="Imprimir / descargar aguinaldo"
        visible={visible}
        onCancel={onCancel}
        spinning={cargando}
        width={window.innerWidth > 1000 ? "80%" : "95%"}
      >
        <div className="aguinaldo-modal-barra">
          <Space wrap>
            <Checkbox
              checked={conFirma}
              disabled={!datos}
              onChange={(e) => this.setState({ conFirma: e.target.checked }, () => this.armarPdf())}
            >
              Columna de firma (renglones más altos)
            </Checkbox>
            {datos?.isrIncompleto && (
              <Alert
                type="warning"
                showIcon
                message="Hay empleados sin ISR calculado: salen con guion."
              />
            )}
          </Space>
          <Space>
            <ButtonItem type="primary" icon={<FilePdfOutlined />} onClick={this.descargarPdf} disabled={!datos}>
              Descargar PDF
            </ButtonItem>
            <ButtonItem icon={<FileExcelOutlined />} onClick={this.descargarExcel} disabled={!datos}>
              Descargar Excel
            </ButtonItem>
            <ButtonItem danger onClick={onCancel}>
              Cerrar
            </ButtonItem>
          </Space>
        </div>
        <iframe
          ref={this.iframeRef}
          title="pdfAguinaldo"
          style={{ width: "100%", height: "75vh", border: "1px solid #f0f0f0" }}
        />
      </ModalItem>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(ModalImpresionAguinaldo);
